import React from 'react';
import { VictoryCursorContainer, VictoryLabel, VictoryScatter,  VictoryLine, VictoryClipContainer, VictoryBar, VictoryChart, VictoryTheme, VictoryAxis, VictoryCandlestick } from 'victory';

import ChartPeriods from './ChartPeriods';
import AlertStore from './AlertStore';

import axios from 'axios'

import CircleLoader from "react-spinners/CircleLoader";
import * as Actions from "./Actions"
import './StockChart.css'

function addYears(date, years) {
  return new Date(date.getFullYear() + years, date.getMonth(), date.getDate())
}

function addMonths(date, months) {
  return new Date(date.getFullYear(), date.getMonth() + months, date.getDate())
}

class StockChart extends React.Component {

  cursorLabel(a, b) {
    Actions.chartCoordinatesChanged(a, b);
    var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(a)
    var mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(a)
    var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(a)
    return  Math.round((b + Number.EPSILON) * 100) / 100 + "   (" + `${da}-${mo}-${ye}` + ")";
  }

  render(){
    if (this.state.period && this.eodData && this.state.alert) {
      var eodFragment = this.createFragmentData(this.state.period, this.eodData);
      var chartData = this.createChartData(this.state.alert, eodFragment, this.eodData);
      var yModeParam = this.state.yMode && this.state.yMode != "standard" ? 0 : undefined;
    }

    return (
      <div id="rightcontent">
        {this.state.loading ? <CircleLoader size="250" /> :
        eodFragment ?
          <div id="chartmainframe">
          <div id="chartcontentframe" onClick={() => Actions.chartCoordinatesSelected()}>
          <VictoryChart theme={VictoryTheme.material} minDomain={{ y: yModeParam }} scale={{ x: "time" }}
          containerComponent={
            <VictoryCursorContainer
              cursorLabel={({ datum }) => `${this.cursorLabel(datum.x, datum.y)}`}
              />
            }>
          <VictoryLabel x={25} y={5} text={this.lastAlert.name}/>

          <VictoryAxis tickFormat={(x) => x.toLocaleString().split(',')[0]} />
          <VictoryAxis dependentAxis />
          <VictoryCandlestick
              candleColors={{ positive: "#5f5c5b", negative: "#c43a31" }}
              data={eodFragment}>
          </VictoryCandlestick>

          {chartData.maxLine ?
          <VictoryLine
                style={{ data: { stroke: "green", strokeWidth: 1 } }}
              data={chartData.maxLine}
              /> : undefined
            }

          {chartData.minLine ?
          <VictoryLine
              style={{ data: { stroke: "red", strokeWidth: 1} }}
              data={chartData.minLine}
              /> : undefined }

          {chartData.sma ?
          <VictoryLine
              groupComponent={<VictoryClipContainer clipPadding={{ top: 5, right: 10 }}/>}
              style={{ data: { stroke: "blue", strokeWidth: 1 }}}
              data={chartData.sma}
              /> : undefined
          }
        <div/>
        </VictoryChart>
        </div>

        <ChartPeriods value={this.state.period} yModeZerobase={this.state.yMode}
          onYModeChanged={
            (x) => { this.setState({yMode:x});}
          }
          onChange={
            (x) => this.setState({period:x,})
          }>
          </ChartPeriods>
        </div>
        :undefined}
      </div>
    )
  }

  componentWillMount() {
    this.setState({
      period:"1Y",
      yMode:"standard"
    });
      AlertStore.on("present", () => {
        this.loadData(AlertStore.getSelectedAlert(), () => {
           this.setState({
             alert:AlertStore.getSelectedAlert(),
           });
        });
     });
  }

  componentWillUnmount() {
    AlertStore.removeListener("present");
  }

  createChartData(alert, eodData, eodDataTot) {
    var data = {};
    if (alert.type == "standard") {
      if (eodData && eodData.length > 0) {
        if(eodData[eodData.length -1].x != eodDataTot[eodDataTot.length -1].x) {
          throw eodDataTot;
        }
        if (alert.min) {
          data.minLine = [
             {x:eodData[0].x, y : parseFloat(alert.min)},
             {x:eodData[eodData.length -1].x, y : parseFloat(alert.min)}
           ];
        }
        if (alert.max) {
          data.maxLine = [
             {x: eodData[0].x, y : parseFloat(alert.max)},
             {x: eodData[eodData.length -1].x, y : parseFloat(alert.max)}
           ];
        }
        if (alert.sma && parseFloat(alert.sma) > 0) {
          if (eodData && parseFloat(alert.sma) < eodData.length) {
            var sma = []
            var tmpSum = 0
            var hypStartIndex = (eodDataTot.length - parseFloat(alert.sma) - eodData.length);
            var index = Math.max(hypStartIndex, 0);
            var recordBorder = index + parseFloat(alert.sma);
            var tmpSum = 0;
            for ( ; index < eodDataTot.length; index++) {
              tmpSum += eodDataTot[index].close;
              if(index >= recordBorder ) {
                tmpSum -= eodDataTot[index - parseFloat(alert.sma)].close;
                sma.push({x: eodDataTot[index].x, y:tmpSum/parseFloat(alert.sma)});
              }
            }
            data.sma = sma;
          }
        }
      }
    }
    return data
  }

  createFragmentData(period, eodData) {
    var period = this.state.period;
    var newEodData = [];
    var tresholdDate = null;
    var freshDate = eodData[eodData.length-1].x;

    if(period == "3M") {
      tresholdDate = addMonths(freshDate, -3);
    }
    else if(period == "6M") {
      tresholdDate = addMonths(freshDate, -6);
    }
    else if(period == "YTD") {
      tresholdDate = new Date(freshDate.getFullYear(), 0, 1);
    }
    else if(period == "1Y") {
      tresholdDate = addYears(freshDate, -1);
    }
    else if(period == "2Y") {
      tresholdDate = addYears(freshDate, -2);
    }
    else if(period == "5Y") {
      tresholdDate = addYears(freshDate, -5);
    }
    else if(period == "10Y") {
      tresholdDate = addYears(freshDate, -10);
    }
    else if(period == "Max") {
      tresholdDate = eodData[0].x;
    }
    if (!eodData) {
      return null;
    }
    for(let i = 0; i < eodData.length; i++) {
      if (eodData[i].x.getTime() >= tresholdDate.getTime()) {
        newEodData.push(eodData[i]);
      }
    }
    return newEodData;
}

loadData(alert, callback){
  if(alert == null || alert.symbol == null || "" == alert.symbol || alert.exchange == null || "" == alert.exchange) {
    this.lastAlert = null;
    this.eodData = null
    callback();
    return;
  }
  if (this.lastAlert && this.lastAlert.symbol == alert.symbol) {
    callback()
    return;
  }
   this.setState({
     loading:true
   },
    ()=>{
      axios.get(window.location.href.toString() + "eoddata" + "?" + "symbol=" + alert.symbol + "&" + "exchange=" + alert.exchange)
      .then(resp => {
        var kata = resp.data;
        for (var index = 0; index < kata.length; index++) {
          var d = kata[index];
          d.x = new Date(d.date);
          delete d.date;
        }
        this.lastAlert = alert;
        this.eodData=kata;
        this.setState( {
            loading:false,
        }, () => callback())

      })
      .catch(function (error) {
        window.alert("unable to load eoddata " + (error.response && error.response.statusText ? error.response.statusText : error));
      });
    }
   )

  }
}
export default StockChart;
